import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=61d9923c&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d9923c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/ubq-h5_build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61d9923c')) {
      api.createRecord('61d9923c', component.options)
    } else {
      api.reload('61d9923c', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=61d9923c&scoped=true&", function () {
      api.rerender('61d9923c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/base/Header.vue"
export default component.exports